/* eslint-disable */
// @ts-nocheck
import {
  CargoStatus,
  DispatchStatus,
  ProductMovementType,
  ReceiptPaymentStatus,
  ReceiptStatus,
} from '../interfaces/ServerInterfaces'

export const translateProductTypes = (type?: string) => {
  switch (type) {
    case 'MENU':
      return 'Elaborado'

    case 'STOCK':
      return 'Almacén'

    case 'COMBO':
      return 'Combo'

    case 'SERVICE':
      return 'Servicio'

    case 'VARIATION':
      return 'Variable'

    case 'ADDON':
      return 'Agrego'

    case 'RAW':
      return 'Materia Prima'

    case 'MANUFACTURED':
      return 'Procesado'

    case 'WASTE':
      return 'Desecho'

    case 'ASSET':
      return 'Activo'

    case 'INPUT':
      return 'Insumo'

    default:
      return ''
  }
}

export const translateAreaType = (type?: string) => {
  if (type === undefined) return ''
  switch (type) {
    case 'STOCK':
      return 'Almacén'
    case 'SALE':
      return 'Punto de venta'
    case 'MANUFACTURER':
      return 'Procesado'
    case 'ACCESSPOINT':
      return 'Punto de Acceso'
    default:
      return ''
  }
}

export const translateWeekDays = (day?: string) => {
  if (day === undefined) return ''
  switch (day) {
    case 'Sunday':
      return 'DOMINGO'
    case 'Monday':
      return 'LUNES'
    case 'Tuesday':
      return 'MARTES'
    case 'Wednesday':
      return 'MIÉRCOLES'
    case 'Thursday':
      return 'JUEVES'
    case 'Friday':
      return 'VIERNES'
    case 'Saturday':
      return 'SÁBADO'
    default:
      return day ?? ''
  }
}

export const translateMeasure = (value?: string) => {
  switch (value) {
    case 'DRINK':
      return 'Trago'

    case 'POUND':
      return 'Lb'

    case 'KG':
      return 'Kg'

    case 'UNIT':
      return 'U'

    case 'LITRE':
      return 'L'

    case 'PORTION':
      return 'Porción'

    default:
      return ''
  }
}

export const translateOperation = (operation?: string | null) => {
  switch (operation) {
    // Movement Operations
    case 'ENTRY':
      return 'Entrada'
    case 'OUT':
      return 'Salida'

    // Movement Categories
    case 'TRASLATE':
      return 'Traslado'
    case 'SALE':
      return 'Venta'
    case 'BUY':
      return 'Compra'
    case 'FAST_ENTRY':
      return 'Entrada Rápida'
    case 'ADJUST':
      return 'Ajuste'
    case 'DESCOMPOSITION':
      return 'Descomposición'
    case 'ELABORATION':
      return 'Elaboración'
    case 'DISPATCH':
      return 'Despacho'
    case 'CONTAINER':
      return 'Contenedor'
    case 'EXTRACTION':
      return 'Extracción'
    case 'WASTE':
      return 'Desperdicios'
    case 'TRANSFORMATION':
      return 'Transformación'
    case 'REFUNDED':
      return 'Reembolsado'

    // Legacy/Additional Operations (for backward compatibility)
    case 'EXIT':
      return 'Salida'
    case 'MOVEMENT':
      return 'Movimiento'
    case 'PROCESSED':
      return 'Procesado'
    case 'REMOVED':
      return 'Eliminado'

    // Default case
    case null:
    case undefined:
    case '':
      return 'Sin especificar'
    default:
      return operation || 'Desconocido'
  }
}

export const translateEcoCycleTab = (tab?: string) => {
  switch (tab) {
    case 'details':
      return 'Detalles'

    case 'orders':
      return 'Órdenes'

    case 'reports':
      return 'Reportes'

    case 'cashbox':
      return 'Caja'

    default:
      return ''
  }
}

export const translateDispatchStatus = (
  status?: DispatchStatus | ReceiptStatus
) => {
  switch (status) {
    case 'ACCEPTED':
      return 'Recibido'

    case 'REJECTED':
      return 'Rechazado'

    case 'CREATED':
      return 'Creado'

    case 'CANCELLED':
      return 'Cancelado'

    case 'CONFIRMED':
      return 'Confirmado'

    case 'DISPATCHED':
      return 'Despachado'

    case 'BILLED':
      return 'Facturado'

    case 'READY_TO_TRANSPORT':
      return 'Listo para transportar'

    case 'INTERNATIONAL_TRANSIT':
      return 'En tránsito internacional'

    case 'ORIGIN_RECEIVED':
      return 'Recibido en origen'

    case 'NATIONAL_TRANSIT':
      return 'En tránsito nacional'

    case 'WAREHOUSE_RECEIVED':
      return 'Recibido en almacenes'

    case 'ARCHIVED':
      return 'Archivado'

    case 'AVAILABLE':
      return 'Disponible'

    case 'PARTIALLY_AVAILABLE':
      return 'Parcialmente disponible'

    case 'OUT_OF_STOCK':
      return 'Agotado'

    case 'PAYMENT_PENDING':
      return 'Pendiente de pago'

    case 'PARTIALLY_PAID':
      return 'Parcialmente pagado'

    case 'PENDING_TO_ARRIVE':
      return 'Pendiente de llegar'

    case 'PAID':
      return 'Pagado'

    default:
      return status
  }
}

export const translateReceiptPaymentsType = (status?: ReceiptPaymentStatus) => {
  switch (status) {
    case 'SUPPLIER':
      return 'Proveedor'

    case 'OPERATIONAL':
      return 'Operacional'

    case 'INDIRECT':
      return 'Indirecto'

    default:
      return status
  }
}

export const translateProductMovementType = (status?: ProductMovementType) => {
  switch (status) {
    case 'SALE':
      return 'Venta'

    case 'OUT':
      return 'Salida'

    case 'DISPATCH':
      return 'Despacho'

    default:
      return status
  }
}

export const translateCargoStatus = (status?: CargoStatus) => {
  switch (status) {
    case 'CREATED':
      return 'Creado'

    case 'READY_TO_TRANSPORT':
      return 'Listo para transportar'

    case 'INTERNATIONAL_TRANSIT':
      return 'En tránsito internacional'

    case 'ORIGIN_RECEIVED':
      return 'Recibido en origen'

    case 'NATIONAL_TRANSIT':
      return 'En tránsito nacional'

    case 'WAREHOUSE_RECEIVED':
      return 'Recibido en almacenes'

    case 'ARCHIVED':
      return 'Archivado'

    case 'CANCELLED':
      return 'Cancelado'

    // Additional container statuses
    case 'DESTINY_ARRIVED':
      return 'Llegado a destino'

    case 'BORDER_RELEASED':
      return 'Liberado en frontera'

    case 'READY_TO_EMPTY_RETURN':
      return 'Listo para retorno vacío'

    case 'EMPTY_RETURNED':
      return 'Retorno vacío completado'

    default:
      return ''
  }
}
export const translateOrderStatePay = (status: string) => {
  switch (status) {
    case 'PARTIAL_PAYMENT':
      return 'Pago parcial'

    case 'PAYMENT_PENDING':
      return 'Pendiente de pago'

    case 'PAID':
      return 'Pagada'

    case 'BILLED':
      return 'Pagada'

    case 'PRE_BILLED':
      return 'Pre-facturada'

    case 'CANCELLED':
      return 'Cancelada'

    case 'REFUNDED':
      return 'Reembolsada'

    case 'PARTIALLY_REFUNDED':
      return 'Parcialmente reembolsada'

    case 'PARTIALLY_PAID':
      return 'Parcialmente pagada'

    case 'APPROVED':
      return 'Aprobada'

    case 'PENDING_APPROVAL':
      return 'Pendiente de aprobación'

    case 'REJECTED':
      return 'Rechazada'

    case 'CONFIRMED':
      return 'Confirmada'

    default:
      break
  }
}

export const translateOrderState = (status: string | null) => {
  switch (status) {
    case 'CREATED':
      return 'Creada'

    case 'ACTIVE':
      return 'Activa'

    case 'INACTIVE':
      return 'Inactiva'

    case 'CLOSED':
      return 'Cerrada'

    case 'DISPATCHED':
      return 'Despachada'

    case 'RECEIVED':
      return 'Recibida'

    case 'IN_PROCESS':
      return 'En proceso'

    case 'PROCESSED':
      return 'Procesada'

    case 'COMPLETED':
      return 'Completada'

    case 'DELIVERY_ASSIGNED':
      return 'Asignada a mensajero'

    case 'ACCEPTED':
      return 'Aceptada por mensajero'

    case 'PAYMENT_PENDING':
      return 'Pendiente de pago'

    case 'WAITING':
      return 'En espera'

    case 'CANCELLED':
      return 'Cancelada'

    case 'REFUNDED':
      return 'Reembolsada'

    case 'WITH_ERRORS':
      return 'Con errores'

    case 'BILLED':
      return 'Pagada'

    case 'IN_TRANSIT':
      return 'En tránsito'

    case 'DELIVERED':
      return 'Entregada'

    case 'PREFECTURE':
      return 'Pre-facturada'

    case 'PRE_BILLED':
      return 'Pre-facturada'

    case 'PAID':
      return 'Pagada'

    case 'USED':
      return 'Utilizado'

    case 'OVERDUE':
      return 'Pago vencido'

    case 'PARTIALLY_PAID':
      return 'Parcialmente pagada'

    case 'PARTIALLY_COMPLETED':
      return 'Parcialmente completada'

    case 'PARTIALLY_REFUNDED':
      return 'Parcialmente reembolsada'

    case 'PENDING':
      return 'Pendiente'

    case 'APPROVED':
      return 'Aprobada'

    case 'PENDING_APPROVAL':
      return 'Pendiente de aprobación'

    case 'REJECTED':
      return 'Rechazada'

    case 'CONFIRMED':
      return 'Confirmada'

    // Container-specific statuses
    case 'READY_TO_TRANSPORT':
      return 'Listo para transportar'

    case 'ORIGIN_RECEIVED':
      return 'Recibido en origen'

    case 'INTERNATIONAL_TRANSIT':
      return 'En tránsito internacional'

    case 'DESTINY_ARRIVED':
      return 'Llegado a destino'

    case 'BORDER_RELEASED':
      return 'Liberado en frontera'

    case 'NATIONAL_TRANSIT':
      return 'En tránsito nacional'

    case 'WAREHOUSE_RECEIVED':
      return 'Recibido en almacén'

    case 'READY_TO_EMPTY_RETURN':
      return 'Listo para retorno vacío'

    case 'EMPTY_RETURNED':
      return 'Retorno vacío completado'

    default:
      return status || ''
  }
}

export const translateOrderAction = (action: string | null) => {
  switch (action) {
    // Creation & Basic States
    case 'ORDER_CREATED':
      return 'Creada'

    case 'ORDER_EDITED':
      return 'Editada'

    case 'PRODUCT_ADDED':
      return 'Producto agregado'

    case 'PRODUCT_REMOVED':
      return 'Producto eliminado'

    case 'ORDER_MOVED':
      return 'Movida'

    case 'ORDER_REOPEN':
      return 'Reabierta'

    // Completion States
    case 'ORDER_CLOSED':
      return 'Cerrada'

    case 'ORDER_DISPATCHED':
      return 'Despachada'

    case 'IN_PROCESS':
      return 'Procesando'

    case 'COMPLETED':
      return 'Completada'

    case 'PARTIALLY_COMPLETED':
      return 'Parcialmente completada'

    case 'PENDING':
      return 'Pendiente'

    // Payment States
    case 'WAITING':
      return 'En espera'

    case 'ORDER_CANCELLED':
    case 'RESERVATION_CANCELLED':
      return 'Cancelada'

    case 'ORDER_REFUNDED':
    case 'RESERVATION_REFUNDED':
      return 'Reembolsada'

    case 'WITH_ERRORS':
      return 'Con errores'

    case 'ORDER_BILLED':
      return 'Pagada'

    case 'ORDER_PARTIAL_BILLED':
      return 'Pago parcial'

    case 'ORDER_REMOVED_BILLED':
      return 'Factura eliminada'

    case 'PAYMENT_FAILS':
      return 'Pago fallido'

    case 'ADVANCE_PAYMENT_USED':
      return 'Pago anticipado'

    case 'PAYMENT_REMINDER_SENT':
      return 'Recordatorio enviado'

    case 'TRANSFORMED_TO_INVOICE':
      return 'Transformada a factura'

    case 'PARTIAL_PAYMENT_REMOVED':
      return 'Pago parcial eliminado'

    case 'PAYMENT_REMOVED':
      return 'Pago eliminado'

    // Miscellaneous
    case 'ORDER_SYNCRONIZED':
      return 'Sincronizada'

    default:
      return ''
  }
}

export const translateInvoiceState = (status?: string | null) => {
  switch (status) {
    case 'APPROVED':
      return 'Aprobada'

    case 'REJECTED':
      return 'Rechazada'

    case 'CLOSED':
      return 'Cerrada'

    default:
      return ''
  }
}

export const translatePaymetMethods = (status?: string | null) => {
  switch (status) {
    case 'CASH':
      return 'Efectivo'

    case 'TRANSFER':
      return 'Transferencia'

    case 'CARD':
      return 'Tarjeta'

    case 'CREDIT_POINT':
      return 'Puntos'

    default:
      return status ?? ''
  }
}
export const translatePaymetMethodsReduce = (status?: string | null) => {
  switch (status) {
    case 'CASH':
      return 'Ef'

    case 'TRANSFER':
      return 'Tr'

    case 'CARD':
      return 'Ta'

    case 'CREDIT_POINT':
      return 'P'

    default:
      return status ?? ''
  }
}
export const translatePaymetMethodsShort = (status?: string | null) => {
  switch (status) {
    case 'CASH':
      return 'E'

    case 'TRANSFER':
      return 'T'

    case 'CARD':
      return 'Tj'

    case 'CREDIT_POINT':
      return 'P'

    default:
      return status ?? ''
  }
}

export const translateTypeHomeDelivery = (status?: string | null) => {
  switch (status) {
    case 'FIXED':
      return 'FIJA'

    case 'VARIABLE':
      return 'VARIABLE'

    case 'BYREGION':
      return 'POR REGIÓN'

    case 'BYKILOMETER':
      return 'POR KILÓMETROS'

    default:
      return ''
  }
}

export const translateMonths = (month?: string) => {
  switch (month) {
    case 'January':
      return 'Enero'
    case 'February':
      return 'Febrero'
    case 'March':
      return 'Marzo'
    case 'April':
      return 'Abril'
    case 'May':
      return 'Mayo'
    case 'June':
      return 'Junio'
    case 'July':
      return 'Julio'
    case 'August':
      return 'Agosto'
    case 'September':
      return 'Septiembre'
    case 'October':
      return 'Octubre'
    case 'November':
      return 'Noviembre'
    case 'December':
      return 'Diciembre'
    default:
      return ''
  }
}

export const convertBoolean = (status: string | null) => {
  switch (status?.toLowerCase()) {
    case 'true':
      return true

    case 'false':
      return false

    default:
      return ''
  }
}

export const translateRegWay = (reg?: string) => {
  switch (reg) {
    case 'woo':
      return 'Woocommerce'

    case 'pos':
      return 'Punto de venta'

    case 'online':
      return 'Tienda online'

    default:
      return '-'
  }
}

export const translateOrderOrigin = (origin: string) => {
  switch (origin) {
    case 'pos':
      return 'Punto de venta'

    case 'woo':
      return 'Woocommerce'

    case 'online':
      return 'Tienda online'

    case 'admin':
      return 'Administración'

    case 'shop':
      return 'Tienda Web'

    case 'shopapk':
      return 'Tienda APK'

    case 'marketplace':
      return 'Marketplace'

    case 'apk':
      return 'Tecopos–Terminal'

    case 'external':
      return 'Externo'

    default:
      return ''
  }
}

export const translateActionRecords = (origin: string) => {
  switch (origin) {
    case 'EDIT_GENERAL_DATA':
      return 'Editar datos generales'

    case 'OBSERVATION':
      return 'Observaciones'

    case 'LOW_PERSON':
      return 'Baja'

    case 'HIGH_PERSON':
      return 'Alta'

    default:
      return origin
  }
}

export const translateCoupons = (coupon: string) => {
  switch (coupon) {
    case 'PERCENT':
      return 'Porciento'

    case 'FIXED_PRODUCT':
      return 'Fijo a producto'

    case 'FIXED_CART':
      return 'Fijo al carrito'

    default:
      return coupon
  }
}

export const translateMovementCategory = (category: string) => {
  switch (category) {
    case 'TRASLATE':
      return 'Traslado'

    case 'SALE':
      return 'Venta'

    case 'ELABORATION':
      return 'Elaboración'

    case 'DESCOMPOSITION':
      return 'Descomposición'

    case 'BUY':
      return 'Compra'

    case 'ADJUST':
      return 'Ajuste'

    case 'PROCESSED':
      return 'Procesado'

    case 'DISPATCH':
      return 'Despacho'

    case 'CONTAINER':
      return 'Contenedor'

    case 'EXTRACTION':
      return 'Extracción'

    case 'FAST_ENTRY':
      return 'Entrada rápida'

    case 'WASTE':
      return 'Desperdicio'

    case 'REFUNDED':
      return 'Reembolsado'

    case 'TRANSFORMATION':
      return 'Transformación'

    case 'OUT':
      return 'Salida'

    case 'MENU':
      return 'Elaborado'

    case null:
      return '-'

    default:
      return category
  }
}

export const translateCostTypes = (type: string) => {
  switch (type) {
    case 'SUPPLIER':
      return 'Proveedor'

    case 'OPERATIONAL':
      return 'Operacional'

    case 'INDIRECT':
      return 'Indirecto'

    case null:
      return '-'

    default:
      return type
  }
}

export const translatePersonStatus = (type: string) => {
  switch (type) {
    case 'TEST':
      return 'Prueba'

    case 'HIRED':
      return 'Contratado'

    case 'NOT_DEFINED':
      return 'No definido'

    case 'PENDING':
      return 'Pendiente'

    case 'LEAVE':
      return 'Baja'

    case null:
      return '-'

    default:
      return type
  }
}

export const translateExpedientState = (status: string | null) => {
  switch (status) {
    case 'CREATED':
      return 'Creado'

    case 'CLOSED':
      return 'Cerrado'

    case 'CANCELLED':
      return 'Cancelado'

    default:
      return ''
  }
}
